/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios'
import { clientIdentity } from 'common/utils/types/helpers/client-identity'
import packageInfo from '../../../package.json'

interface XHRProps {
  url: string
  method: 'GET' | 'POST' | 'PUT' | 'DELETE'
  parameters?: any
  data?: any
}

export default function xhr({ url, method, parameters, data }: XHRProps) {
  // The server rejects a client block whose code or device is empty, which is what the stored
  // device code is on a first visit (an unauthenticated page such as signup). clientIdentity
  // generates and remembers valid codes, and is what ajax-connection2 already uses.
  return axios({
    url,
    method,
    data: {
      client: {
        device: clientIdentity.deviceCode(),
        code: clientIdentity.clientCode(),
        locale: 'en',
        target: 'web',
        version: packageInfo.version,
      },
      ...data,
    },
    params: parameters,
  })
}
